import { useState } from 'react';
import { api, errorText, queryClient } from '../../api.ts';
import { Button, ErrorLine } from '../ui.tsx';
import { stepIconsKey, type StepIcons } from './stepIcons.ts';

/** The tree's pictures: how many are painted, and painting the rest (an OpenAI image each), for an admin to start. */
export function StepPictures({ icons, editable }: { icons: StepIcons; editable: boolean }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const d = icons.data;
  if (!d) return null;
  const paint = async () => {
    setBusy(true);
    setErr(null);
    try {
      queryClient.setQueryData(stepIconsKey, await api('/process/step-icons', { body: {} }));
    } catch (e) {
      setErr(errorText(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="text-sm">
      <p className="text-ink-2">
        <span className="label mr-2">Pictures</span>
        {d.icons.length} {d.icons.length === 1 ? 'step has' : 'steps have'} a painted picture
        {d.painting ? <span className="motion-safe:animate-pulse">; {d.painting} being painted now</span> : null}
        {d.missing ? `; ${d.missing} still drawn as a mark` : ''}.{' '}
        {editable && d.missing && !d.painting ? (
          d.blocked ? (
            <span className="text-ink-3">{d.blocked}</span>
          ) : (
            <Button tone="quiet" busy={busy} onClick={() => void paint()}>
              Paint the {d.missing} still missing
            </Button>
          )
        ) : null}
      </p>
      <ErrorLine error={err} />
    </div>
  );
}
